// 3D module exports - requires optional dependencies
export * from "./3d/index"
export * as THREE from "three"
